<template>
  <div class="marktit">
      <div class="mleft">
         <v-md-preview @click="handleClickImage($event.target.src)" :text="text" ref="preview" ></v-md-preview>
      </div>
      <el-affix target=".marktit" position="top" :offset="120" :bound="92">
        <el-anchor type="underline">
          <el-anchor-link
            v-for="(anchor ,index ) in titles"
            :key="index"
            @click="anchorSc(anchor, $event)"
            :href="`#${anchor.title}`"
          >
            {{ anchor.title }}
          </el-anchor-link>
        </el-anchor>
        <ul v-show="false">
            <li
                v-for="(anchor ,index ) in titles"
                :key="index"
                :class="{'act': midx == index } "
                
                @click="handleAnchorClick(anchor,index)"
                >
                <a class="text1 point" :style="{ marginLeft: ` ${anchor.indent * 20}px` }" >{{ anchor.title }}</a>
            </li>
        </ul>
      </el-affix>
      <el-dialog :close-on-click-modal="false" title="查看" width="1100px" v-model="imgShow">
        <img class="ww100" :src="imgUrl" alt="">
      </el-dialog>
  </div>
</template>
<script>

export default {
  data() {
    return {
      titles: [],
      midx: 0,
      t1: 0,
      t2: 0,
      timer : null,
      scrollTop: 0,
      imgShow:false,
      imgUrl:'',
    };
  },
  props:{
      text:{
          type: String,
          default: ''
      }
  },
  watch:{
      text :{
          handler(val,old){
              if(val != old){
                this.$nextTick(()=>{
                    this.msatrt()
                })
              }
          },
          deep: true
      },
      scrollTop(newValue, oldValue) {

        setTimeout(() => {

            if(newValue == window.scrollY) { //延时执行后当newValue等于window.scrollY，代表滚动结束
                this.oldScrollTop = newValue; //每次滚动结束后都要给oldScrollTop赋值
            };

        }, 20); //必须使用延时器，否则每次newValue和window.scrollY都相等，无法判断，20ms刚好大于watch的侦听周期，故延时20ms

        if(this.oldScrollTop == oldValue) { //每次滚动开始时oldScrollTop与oldValue相等


        }
      }
  },
  mounted() {
      var that = this;
    window.onscroll = function() {
        
        //为了保证兼容性，这里取两个值，哪个有值取哪一个
        // scrollTop就是触发滚轮事件时滚轮的高度
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        that.$nextTick(()=>{
            that.scrollTop = scrollTop;
        })
    }
      
  },
  methods: {
    
		handleClickImage(e){
			if(e){
				this.imgShow = true
				this.imgUrl = e
			}
		},
    msatrt(){
        const anchors = this.$refs.preview.$el.querySelectorAll('h1,h2,h3,h4,h5,h6');
        const titles = Array.from(anchors).filter((title) => !!title.innerText.trim());

        if (!titles.length) {
            this.titles = [];
            return;
        }

        const hTags = Array.from(new Set(titles.map((title) => title.tagName))).sort();

        this.titles = titles.map((el) => {
          el.id = el.innerText
            return {
              title: el.innerText,
              lineIndex: el.getAttribute('data-v-md-line'),
              indent: hTags.indexOf(el.tagName),
              top: el.offsetTop -120
            }
        });
    },
    anchorSc(anchor, e) {
      e.preventDefault()
      // this.$refs.preview.scrollToTarget({
      //     target: window[anchor.title],
      //     scrollContainer: window,
      //     top: 20,
      //   });
    },
    handleAnchorClick(anchor,idx) {
      this.midx = idx;
        const { preview } = this.$refs;
      const { lineIndex } = anchor;

      const heading = preview.$el.querySelector(`[data-v-md-line="${lineIndex}"]`);

      if (heading) {
        preview.scrollToTarget({
          target: heading,
          scrollContainer: window,
          top: 120,
        });
      }
    },

  },
};
</script>
<style lang="scss" scoped>
.marktit{
    display: flex;
    align-items: flex-start;
    ul{
        max-width: 300px;
        min-width: 200px;
        // padding: 0px 0 0px 35px;
        font-size: 12px;
        li{
            width: fit-content;
            padding: 10px 0 10px 35px;
            border-left: 2px solid #E5E5E5;
            a{
              color: #737373;
            }
        }
        >.act{
            border-color: #FF6A00;
            a{ color: #FF6A00;}
        }
    }
    // .colorg
}
.mleft{
    width: calc( 100% - 250px ) ;
    padding-right: 30px;
}
</style>